import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'multiArgSearch',
    pure: false
})
@Injectable()
export class MultiArgSearchPipe implements PipeTransform {

    transform(items: any[], filter: string, searchBy?: any): any {
        if (!items) return [];
        if (!filter) return items;
        filter = filter.toLowerCase();
        return items.filter(
          (item) => {
            if (searchBy && searchBy.length > 0) {
              let check = false;
              _.each(searchBy, (search) => {
                if (item[search] && item[search].toString().toLowerCase().indexOf(filter) !== -1) {
                  check = true;
                }
              });
              return check;
            } else {
              let check = _.find(Object.getOwnPropertyNames(item), (itemProp) => {
                if (item[itemProp] && item[itemProp].toString().toLowerCase().indexOf(filter) !== -1) {
                return true;
                } else {
                  return false;
                }
              });
              if (typeof check !== 'undefined') {
                return true
              } else {
                return false;
              }
            }
          }
        );
    }
}
